export const dictionary = {
  'account-add': 'account-add',
  'account-favorite': 'account-favorite',
  'account-lock': 'account-lock',
  'account-remove': 'account-remove',
  account: 'account',
  'add-alt': 'add-alt',
  add: 'add',
  analytics: 'analytics',
  'arrow-back': 'arrow-back',
  'arrow-collapse': 'arrow-collapse',
  'arrow-down': 'arrow-down',
  'arrow-end': 'arrow-end',
  'arrow-expand': 'arrow-expand',
  'arrow-forward': 'arrow-forward',
  'arrow-left': 'arrow-left',
  'arrow-next-1': 'arrow-next-1',
  'arrow-next': 'arrow-next',
  'arrow-previous': 'arrow-previous',
  'arrow-right': 'arrow-right',
  'arrow-start': 'arrow-start',
  'arrow-up': 'arrow-up',
  'Artboard 125': 'Artboard 125',
  'Artboard 126': 'Artboard 126',
  'Artboard 127': 'Artboard 127',
  'Artboard 128': 'Artboard 128',
  'Artboard 86': 'Artboard 86',
  atm: 'atm',
  attachment: 'attachment',
  'auth-face': 'auth-face',
  'auth-one-time-code': 'auth-one-time-code',
  'auth-reauthorize': 'auth-reauthorize',
  'auth-voice': 'auth-voice',
  balance: 'balance',
  'bill-alt': 'bill-alt',
  bill: 'bill',
  'bonus-points': 'bonus-points',
  bookmark: 'bookmark',
  'bug-debug': 'bug-debug',
  bug: 'bug',
  'business-user': 'business-user',
  calculator: 'calculator',
  calendar: 'calendar',
  'camera-flash': 'camera-flash',
  camera: 'camera',
  'card-corporate': 'card-corporate',
  'card-debit': 'card-debit',
  'card-generic': 'card-generic',
  'card-manage-alt': 'card-manage-alt',
  'card-manage': 'card-manage',
  'card-number': 'card-number',
  'card-off': 'card-off',
  'card-prepaid': 'card-prepaid',
  'card-suspend': 'card-suspend',
  'card-verify': 'card-verify',
  cart: 'cart',
  cash: 'cash',
  category: 'category',
  'check-international': 'check-international',
  check: 'check',
  'checked-multiple': 'checked-multiple',
  checkmark: 'checkmark',
  clear: 'clear',
  close: 'close',
  'cloud-upload': 'cloud-upload',
  cloud: 'cloud',
  'code-fork-code-alt': 'code-fork-code-alt',
  'code-fork-code': 'code-fork-code',
  'code-run': 'code-run',
  company: 'company',
  contact: 'contact',
  controls: 'controls',
  copy: 'copy',
  'currencty-usd': 'currencty-usd',
  'currency-convert-alt': 'currency-convert-alt',
  'currency-convert': 'currency-convert',
  'currency-eur': 'currency-eur',
  'currency-usd': 'currency-usd',
  currency: 'currency',
  'customer-support': 'customer-support',
  delete: 'delete',
  'device-keyboard': 'device-keyboard',
  'device-laptop': 'device-laptop',
  'device-mobile': 'device-mobile',
  'device-monitor': 'device-monitor',
  'device-mouse': 'device-mouse',
  'device-printer': 'device-printer',
  'device-secure': 'device-secure',
  'device-servers': 'device-servers',
  'device-tablet': 'device-tablet',
  'device-tv': 'device-tv',
  'document-add': 'document-add',
  'document-avi': 'document-avi',
  'document-jpg': 'document-jpg',
  'document-json': 'document-json',
  'document-mov': 'document-mov',
  'document-pdf': 'document-pdf',
  'document-png': 'document-png',
  'document-xls': 'document-xls',
  'document-xml': 'document-xml',
  document: 'document',
  drag: 'drag',
  edit: 'edit',
  email: 'email',
  'error-alt': 'error-alt',
  error: 'error',
  export: 'export',
  eyedropper: 'eyedropper',
  'favorite-star-border': 'favorite-star-border',
  'favorite-star': 'favorite-star',
  female: 'female',
  'file-download': 'file-download',
  'file-upload': 'file-upload',
  'filter-alt': 'filter-alt',
  'filter-applied': 'filter-applied',
  filter: 'filter',
  fingerprint: 'fingerprint',
  'folder-a-z': 'folder-a-z',
  'folder-account': 'folder-account',
  'folder-drilldown': 'folder-drilldown',
  'folder-multiple': 'folder-multiple',
  folder: 'folder',
  'gender-female': 'gender-female',
  gift: 'gift',
  global: 'global',
  glossary: 'glossary',
  guide: 'guide',
  help: 'help',
  home: 'home',
  'id-number': 'id-number',
  info: 'info',
  issuer: 'issuer',
  'key-change': 'key-change',
  key: 'key',
  like: 'like',
  link: 'link',
  'log-completed': 'log-completed',
  log: 'log',
  'map-directions': 'map-directions',
  'map-location-off': 'map-location-off',
  'map-location': 'map-location',
  map: 'map',
  maximize: 'maximize',
  'media-fast-forward': 'media-fast-forward',
  'media-pause-alt': 'media-pause-alt',
  'media-pause': 'media-pause',
  'media-play-alt': 'media-play-alt',
  'media-play': 'media-play',
  'media-replay': 'media-replay',
  'media-rewind': 'media-rewind',
  'media-stop-alt': 'media-stop-alt',
  'media-stop': 'media-stop',
  menu: 'menu',
  merchant: 'merchant',
  message: 'message',
  'money-add': 'money-add',
  'money-request': 'money-request',
  'money-send': 'money-send',
  'money-withdraw': 'money-withdraw',
  nfc: 'nfc',
  note: 'note',
  notifications: 'notifications',
  'offers-alt-1': 'offers-alt-1',
  'offers-alt': 'offers-alt',
  'offers-deals': 'offers-deals',
  offers: 'offers',
  options: 'options',
  handshake: 'partner-integrations',
  'password-hide': 'password-hide',
  'password-show': 'password-show',
  phone: 'phone',
  photo: 'photo',
  'pos-alt': 'pos-alt',
  pos: 'pos',
  power: 'power',
  'qr-alt': 'qr-alt',
  question: 'question',
  receipt: 'receipt',
  redo: 'redo',
  refresh: 'refresh',
  reload: 'reload',
  reward: 'reward',
  roadsign: 'roadsign',
  save: 'save',
  'savings-account': 'savings-account',
  scale: 'scale',
  'scan-card': 'scan-card',
  'scan-qr-emvco': 'scan-qr-emvco',
  search: 'search',
  'security-lock': 'security-lock',
  'security-protection': 'security-protection',
  'security-unlock': 'security-unlock',
  security: 'security',
  settings: 'settings',
  share: 'share',
  shipping: 'shipping',
  'sign-in': 'sign-in',
  'sign-out': 'sign-out',
  'signature-alt': 'signature-alt',
  signature: 'signature',
  'sortable-ascending': 'sortable-ascending',
  'sortable-descending': 'sortable-descending',
  sortable: 'sortable',
  'stack-exchange': 'stack-exchange',
  statistics: 'statistics',
  'subtract-alt': 'subtract-alt',
  subtract: 'subtract',
  'success-alt': 'success-alt',
  success: 'success',
  'support-ticket': 'support-ticket',
  'suppot-ticket': 'suppot-ticket',
  table: 'table',
  time: 'time',
  'to-top': 'to-top',
  token: 'token',
  topic: 'topic',
  'transactions-new': 'transactions-new',
  transactions: 'transactions',
  'travel-notifications': 'travel-notifications',
  undo: 'undo',
  'view-grid': 'view-grid',
  'view-list': 'view-list',
  'wallet-default': 'wallet-default',
  wallet: 'wallet',
  warning: 'warning',
  wrench: 'wrench',
  'zoom-in': 'zoom-in',
  'zoom-out': 'zoom-out'
};

export default dictionary;
